<template lang="pug">
	.monitoring-ai-budget
		.page-center-content
			.caption-area
				.back(v-if="Layout.pageOptions.backPage")
					button.btn.btn-sm.btn-ghost-secondary(type="button" @click="Layout.setPage.apply(Layout, Layout.pageOptions.backPage)")
						.icon.fa.fa-angle-double-left
				.caption(:class="{'back-exist': Layout.pageOptions.backPage}") Monitoring AI budget log
			.publishers-table
				DataTable(name="monitoring-ai-budget" entity="monitoring_ai_budget" :fields="fields" :filters="filters" :buttons="buttons" key-field="id" :sort="['date', 'desc']" :update-on="['Layout Page Showed:monitoring-ai-budget', 'Monitoring AI Budget Filters Ready']" :update-if="() => Layout.page === 'monitoring-ai-budget'" :height-offset="Layout.headerHeight + 45")
					//- Выключенный переключатель убирает из списка внутренний паблишер Mraid Development (id 18)
					template(slot="header-controls-extra")
						.show-mraid-development
							span Show Mraid Development
							label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
								input.switch-input.form-check-input(type="checkbox" :checked="showMraidDevelopment" @change="setShowMraidDevelopment($event.target.checked)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import DataTable			from './../../components/Templates/DataTable'

	export default {
		name: "MonitoringAIBudget",
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Page Showed:monitoring-ai-budget"]
		},
		components: {
			DataTable
		},
		data() {

			// Внутренний паблишер Mraid Development, записи которого скрываются из лога при выключенном переключателе
			this.MRAID_DEVELOPMENT_PUBLISHER_ID = 18;

			// Имена сущностей (publisher_name, user_name, creative_name, version_name, budget_name) сервер добавляет в строки сам, <deleted> - если сущность уже удалена
			this.fields = [
				{
					fieldName: 'id',
					title: 'ID',
					type: 'number',
					display: false,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '70px'
				},
				{
					fieldName: 'date',
					title: 'Date',
					type: 'date',
					class: 'date-only',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '130px'
				},
				{
					fieldName: 'publisher_id',
					title: 'Company',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '200px',
					displayTransform: (value, row) => row["publisher_name"]
				},
				{
					fieldName: 'user_id',
					title: 'User',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '200px',
					displayTransform: (value, row) => row["user_name"]
				},
				{
					fieldName: 'creative_id',
					title: 'Creative',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '200px',
					displayTransform: (value, row) => row["creative_name"]
				},
				{
					fieldName: 'version_id',
					title: 'Version',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '200px',
					displayTransform: (value, row) => row["version_name"]
				},
				{
					fieldName: 'budget_type',
					title: 'Budget',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '90px'
				},
				{
					fieldName: 'budget_id',
					title: 'Budget name',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '200px',
					displayTransform: (value, row) => row["budget_name"]
				},
				{
					fieldName: 'action_type',
					title: 'Action',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '160px'
				},
				{
					fieldName: 'amount',
					title: 'Amount',
					type: 'number',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '100px',
					displayTransform: value => value < 0 ? '-$' + Math.abs(value) : '$' + value
				}
			];

			this.filters = [{

				// Значение [18] скрывает из лога внутренний паблишер Mraid Development (type not:in), пустое значение - показываем все паблишеры
				title: 'Publisher',
				field: 'publisher_id',
				type: 'not:in',
				value: [this.MRAID_DEVELOPMENT_PUBLISHER_ID],
				display: false

			}];

			this.buttons = [];

			return {
				showed: true,
				showMraidDevelopment: false
			}

		},
		methods: {
			collectData() {

			},
			// Переключатель "Show Mraid Development" в шапке таблицы (слева от Search): выключен (по умолчанию) - записи паблишера Mraid Development (id 18) убираются из списка
			setShowMraidDevelopment(value) {

				this.showMraidDevelopment = !!value;

				// Значение меняем в самом объекте фильтра, чтобы таблица получила его сразу, не дожидаясь перерендера
				this.filters[0].value = this.showMraidDevelopment ? '' : [this.MRAID_DEVELOPMENT_PUBLISHER_ID];

				Broadcast.call('Monitoring AI Budget Filters Ready');

			}
		}
	}
</script>

<style lang="sass" scoped>

	.monitoring-ai-budget
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1600px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: flex-start
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)

				.back
					display: flex
					align-items: center
					justify-content: center
					padding: 0.2rem 1rem

					button
						width: 30px
						height: 30px

				.caption
					padding: 1rem

				.caption.back-exist
					padding: 1rem 0

			.publishers-table
				display: flex
				flex-direction: row
				flex-wrap: wrap
				padding: 1rem 0

				//- Переключатель Show Mraid Development приходит в шапку таблицы через слот, поэтому теперь лежит внутри .header-controls
				.show-mraid-development
					display: flex
					align-items: start
					padding: 4px 15px 0 15px

					&> span
						margin-right: 10px
						user-select: none

					label.switch
						// Перебиваем .header-controls label (display: flex) из DataTable, иначе слайдер переключателя схлопывается по ширине
						display: inline-block
						margin-bottom: 0

</style>

